import React, { PureComponent } from 'react';

import {
	ComposedChart,
	Bar,
	XAxis,
	YAxis,
	Legend,
	ResponsiveContainer,
	AreaChart,
	Area,
	Brush,
	Tooltip,
	CartesianGrid,
	Line,
} from 'recharts';
import data from './E97235.json';

const transformedData = data.map((result) => ({
	...result,
	date_time: result.date_time.toString().substring(8, result.date_time.length - 3),
	max: parseInt(result['p1_event-max-proc']) - parseInt(result['p1_event-min-proc']),
}));

export default class EventTime extends PureComponent {
	render() {
		return (
			<>
				<div className='chart-header' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
					<h1>Event time</h1>
				</div>
				<div>
					<p style={{ marginLeft: 70 }}>Internal diagnostic showing event processing nanoseconds vs. 
					number of events on the queue. Could help detect bottlenecks and issues; the event queue 
					is designed not to have many items at once.</p>
				</div>
				<ResponsiveContainer width={'99%'} height={500}>
					<ComposedChart
						width={500}
						height={500}
						data={transformedData}
						margin={{
							top: 5,
							right: 30,
							left: 20,
							bottom: 5,
						}}
					>
						<CartesianGrid strokeDasharray='3 3' />
						<XAxis dataKey='date_time' />
						<YAxis unit='ns' label={{ value: 'time', position: 'insideLeft', angle: -90, dy: -10 }} />
						<YAxis yAxisId='right' orientation='right' label={{ value: 'events', position: 'insideLeft', angle: -90, dy: -10 }} />
						<Tooltip />
						<Legend />

						<Bar dataKey='p1_event-min-proc' stackId='a' fill='#8884d8' fillOpacity='0' />
						<Bar dataKey='max' stackId='a' fill='#8884d8' stroke='#8884d8' />
						<Line type='monotone' dataKey='p1_event-avg-proc' stroke='red' activeDot={{ r: 8 }} />
						<Line yAxisId="right" type='monotone' dataKey='p1_event-avg' stroke='blue' activeDot={{ r: 8 }} />

						<Brush dataKey='date' endIndex={60}>
							<AreaChart>
								<CartesianGrid />
								<YAxis hide domain={['auto', 'auto']} />
								<Area dataKey='p1_event-avg-proc' stroke='red' fill='red' dot={false} />
							</AreaChart>
						</Brush>
					</ComposedChart>
				</ResponsiveContainer>
			</>
		);
	}
}
